import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import {
  Box, Input, Table, TableCaption, Button, Thead, Tbody, Tr, Th, Td, TableContainer, AlertDialog, useDisclosure,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
} from "@chakra-ui/react";
import toast from 'react-hot-toast';
import Cookie from 'js-cookie';
import KotbillPrintModal from './kotPrintModal';

const KotBillData = () => {
  const [data, setData] = useState([]);
  const token = Cookie.get('token');
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 100; // or any number you prefer

  const [deleteItemId, setDeleteItemId] = useState(null);
  const cancelRef = useRef();
  const {
    isOpen: isPrintOpen,
    onOpen: onPrintOpen,
    onClose: onPrintClose,
  } = useDisclosure();
  const handlePrintModal = () => {

    onPrintOpen();
  };

  const customerId = localStorage.getItem('customerId');

  const fetchData = async () => {
    try {
      const response = await axios.get(`https://api.rcb.tdrsoftware.in/api/getKotBillDataByDateRange/${customerId}?startDate=${startDate}&endDate=${endDate}`)
      setData(response.data);
      setFilteredData(response.data);
    } catch (error) {

    }

  };
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };



  useEffect(() => {
    fetchData();
  }, [customerId, startDate, endDate]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    filterData(event.target.value, startDate, endDate);
  };

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
    filterData(searchTerm, event.target.value, endDate);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
    filterData(searchTerm, startDate, event.target.value);
  };

  const filterData = (term, start, end) => {
    let filtered = data.filter(order => {
      const orderDate = new Date(order.createdAt).getTime();

      console.log(typeof (order.tableNo), "tableNo")
      if (term && !order.tableNo.includes(term)) {
        return false;
      }



      return true;
    });

    setFilteredData(filtered);
  };
  const handleDelete = async () => {
    try {
      const response = await axios.delete(`https://api.rcb.tdrsoftware.in/api/kotDelete/${customerId}/${deleteItemId}?customerId=${customerId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      toast.success(response.data.message);
      setIsOpen(false)
      fetchData();
    } catch (error) {
      if (error.response.status === 403) {
        toast.error(error.response.data.message)
      } else {
        toast.error(error.message)
      }

    }
  }
  const openModal = (id) => {
    setDeleteItemId(id);
    setIsOpen(true);
  };

  const onClose = () => {
    setIsOpen(false);
    setDeleteItemId(null);
  };

  const handleReprint = (order) => {
    console.log("Reprinting Order:", order);

    const printWindow = window.open('', '', 'height=600,width=800');
    printWindow.document.write('<html><head><title>Reprint KOT</title></head><body>');

    // Table info
    printWindow.document.write(`<h2>Reprint - Table: ${order.tableNo}</h2>`);
    printWindow.document.write(`<p><strong>Server:</strong> ${order.serverName}</p>`);

    // KOT details
    printWindow.document.write(`<p><strong>KOT No:</strong> ${order.kotNo}</p>`);
    printWindow.document.write(`<p><strong>Total:</strong> ₹${order.totalBilling}</p>`);
    printWindow.document.write(`<p><strong>Time:</strong> ${new Date(order.createdAt).toLocaleString('en-GB')}</p>`);

    // Item table
    printWindow.document.write('<table border="1" cellspacing="0" cellpadding="5"><thead><tr><th>Item</th><th>Qty</th><th>Price</th></tr></thead><tbody>');

    order.foodItem.forEach(item => {
      printWindow.document.write(`<tr><td>${item.name}</td><td>${item.quantity}</td><td>${item.price}</td></tr>`);
    });

    printWindow.document.write('</tbody></table>');
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.print();
  };


  return (
    <Box overflowX='auto'>
      <Input
        w='40%'
        type="text"
        placeholder="Search by Table Number"
        value={searchTerm}
        onChange={handleSearchChange}
        mb={4} // Adds margin bottom for spacing
      />
      <Input
        w='20%'
        type="date"
        placeholder="Start Date"
        value={startDate}
        onChange={handleStartDateChange}
        mr={2}
      />
      <Input
        w='20%'
        type="date"
        placeholder="End Date"
        value={endDate}
        onChange={handleEndDateChange}
        mr={2}
      />
      <Button colorScheme='teal' onClick={handlePrintModal}>Print</Button>
      <TableContainer width='full'>
        <Table size='sm' variant='striped' colorScheme='green'>
          <TableCaption>Food Data</TableCaption>
          <Thead>
            <Tr>
              <Th>Food Item</Th>
              <Th>TableNo</Th>
              <Th>Server Name</Th>
              <Th>KotNo</Th>
              <Th>Total Bill</Th>
              <Th>Created At</Th>
              <Th>Reprint</Th>
              <Th>Delete</Th>

            </Tr>
          </Thead>
          <Tbody>
            {currentItems.map((order, index) => (
              <Tr key={index}>
                <Td><Table size='xsm' variant='striped' colorScheme='orange'>
                  <Thead>
                    <Tr>
                      <Th>Food Item</Th>
                      <Th>Quantity</Th>
                      <Th>Price</Th>
                    </Tr>
                    {order.foodItem.map((item, index) => (
                      <Tr key={index}>
                        <Td>{item.name}</Td>
                        <Td>{item.quantity}</Td>
                        <Td>{item.price}</Td>
                      </Tr>
                    ))}
                  </Thead>
                </Table></Td>
                <Td>{order.tableNo}</Td>
                <Td>{order.serverName}</Td>
                <Td>{order.kotNo}</Td>
                <Td>{order.totalBilling}</Td>
                <Td>{new Date(order.createdAt).toLocaleString('en-GB')}</Td>
                <Td>
                  <Button colorScheme="blue" size="sm" ml={2} onClick={() => handleReprint(order)}>
                    Reprint
                  </Button>
                </Td>
                <Td>
                  <Button colorScheme="red" size="sm" onClick={() => openModal(order._id)}>
                    Delete
                  </Button>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm Deletion
            </AlertDialogHeader>

            <AlertDialogBody>Are you sure you want to delete this item?</AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleDelete} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      <KotbillPrintModal
        isOpen={isPrintOpen}
        onOpen={onPrintOpen}
        onClose={onPrintClose}
        data={filteredData}

      />
      <Box display="flex" justifyContent="center" mt={4}>
        <Button
          onClick={() => handlePageChange(currentPage - 1)}
          isDisabled={currentPage === 1}
          mr={1}
          size='xsm'
        >
          Prev
        </Button>
        {Array.from({ length: totalPages }, (_, i) => (
          <Button
            key={i}
            size='sm'
            colorScheme='blue'
            onClick={() => handlePageChange(i + 1)}
            variant={currentPage === i + 1 ? "solid" : "outline"}
            mx={1}
          >
            {i + 1}
          </Button>
        ))}
        <Button
          colorScheme='blue'
          size='xsm'
          onClick={() => handlePageChange(currentPage + 1)}
          isDisabled={currentPage === totalPages}
          ml={1}
        >
          Next
        </Button>
      </Box>

    </Box>
  );
};

export default KotBillData;
